import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { appendInputNodeToPipeline } from '../../api/api'; // Import the API function
import { usePipeline } from '../../context/PipelineContext'; // Import the context hook
import { notifyError } from '../../errors/notifyError';
import { OP } from '../../api/operations';
import './Modal.css';
const Modal = ({ isOpen, onClose, nodeName, setNodeName, interval, setInterval, nodeType, setNodeType, onConfigured }) => {
  const { session } = usePipeline(); // Use the context to get the session
  const pipelineName = session.pipeline_name; // Retrieve the pipeline name from the session

  if (!isOpen) return null;

  const handleConfigure = async () => {
    try {
      // Convert interval string to number value
      const intervalValue = interval === '15 mins' ? 15 : 60;
      console.log('Configuring node:', nodeName, pipelineName, intervalValue, nodeType);

      // Make sure we have a valid node name
      if (!nodeName || nodeName.trim() === '') {
        notifyError(new Error('Please enter a valid node name.'), { toastId: 'inputModal.missingName' });
        return;
      }

      // Make the API call to append the node to the pipeline
      // We don't have position information here, so we'll use default values (0,0)
      // The actual position will be updated when the node is placed on the canvas
      if (pipelineName !== "Unsaved_Pipeline") {
        try {
          console.log(`Calling API to append input node: ${nodeName} to pipeline: ${pipelineName}`);
          await appendInputNodeToPipeline(
            pipelineName,
            intervalValue,
            nodeName,
            nodeType,
            0, // Default x position
            0  // Default y position
          );
          console.log(`Successfully added node ${nodeName} to backend`);
        } catch (apiError) {
          console.error('Error calling appendInputNodeToPipeline:', apiError);
          notifyError(apiError, { operation: OP.node.appendInputSelect });
          return;
        }
      }

      // Close the modal and call the callback to place the node on the canvas
      onClose();
      onConfigured(nodeName, nodeType, intervalValue);
    } catch (error) {
      console.error('Error configuring node:', error);
      notifyError(error, { operation: OP.node.appendInputSelect });
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button onClick={onClose} className="modal-close">
          <IoCloseSharp size={24} />
        </button>
        <h2 className="modal-title">Input Node Configuration</h2>
        <div className="modal-field">
          <label>
            Node Name:
            <input
              type="text"
              value={nodeName}
              onChange={(e) => setNodeName(e.target.value)}
              className="modal-input"
            />
          </label>
        </div>
        <div className="modal-field">
          <label>
            Interval:
            <select value={interval} onChange={(e) => setInterval(e.target.value)} className="modal-select">
              <option value="15 mins">15 mins</option>
              <option value="1hr">1hr</option>
            </select>
          </label>
        </div>
        <div className="modal-field">
          <label>
            Type:
            <select value={nodeType} onChange={(e) => setNodeType(e.target.value)} className="modal-select">
              <option value="solar">Solar</option>
              <option value="wind">Wind</option>
            </select>
          </label>
        </div>
        <button className="modal-configure-button" onClick={handleConfigure}>Configure</button>
      </div>
    </div>
  );
};

export default Modal;
